
document.addEventListener('DOMContentLoaded', () => {
  // CONFIGURAZIONE
  const CONFIG = {
    mobileBreakpoint: 768,
    maxHeight: 170, 
    selector: '.product-info__block-item[data-block-type="description"]',
    btnTextOpen: 'LEGGI TUTTO',
    btnTextClose: 'CHIUDI'
  };

  let bgColor = window.getComputedStyle(document.body).backgroundColor;
  if (bgColor === 'rgba(0, 0, 0, 0)' || bgColor === 'transparent') {
    bgColor = '#ffffff'; 
  }

  const style = document.createElement('style');
  style.innerHTML = `
    @media screen and (max-width: ${CONFIG.mobileBreakpoint}px) {
      
      ${CONFIG.selector} {
        position: relative;
        overflow: hidden;
        transition: max-height 0.5s ease-out;
      }

      /* QUANDO È CHIUSO */
      ${CONFIG.selector}.is-truncated {
        max-height: ${CONFIG.maxHeight}px;
      }

      /* LA SFUMATURA MORBIDA */
      ${CONFIG.selector}.is-truncated::after {
        content: "";
        position: absolute;
        bottom: 0; left: 0; width: 100%;
        height: 80px; /* Sfumatura più alta ma più trasparente all'inizio */
        
        /* Gradiente che inizia trasparente e diventa colore sfondo solo alla fine */
        background: linear-gradient(to bottom, transparent 0%, rgba(255,255,255,0) 20%, ${bgColor} 100%);
        
        pointer-events: none;
        transition: opacity 0.3s;
      }

      /* QUANDO È APERTO */
      ${CONFIG.selector}.is-expanded {
        max-height: none;
      }
      ${CONFIG.selector}.is-expanded::after {
        opacity: 0;
        pointer-events: none;
      }

      /* STILE BOTTONE */
      .js-read-more-btn {
        display: block;
        width: 100%;
        background: none; border: none;
        text-align: left;
        
        /* Posizionamento: lo tiriamo su per sovrapporlo leggermente alla fine della sfumatura */
        padding: 0; 
        margin-top: -20px; 
        z-index: 10;
        position: relative;
        
        font-family: inherit;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 700;
        text-decoration: underline;
        text-underline-offset: 3px;
        color: inherit;
        cursor: pointer;
        
        /* Ombreggiatura bianca intorno al testo per renderlo leggibile sopra la sfumatura */
        text-shadow: 0px 0px 10px ${bgColor}, 0px 0px 5px ${bgColor};
      }
    }

    @media screen and (min-width: ${CONFIG.mobileBreakpoint + 1}px) {
      .js-read-more-btn { display: none !important; }
      ${CONFIG.selector} { max-height: none !important; }
    }
  `;
  document.head.appendChild(style);

  // LOGICA JS
  function initReadMore() {
    if (window.innerWidth > CONFIG.mobileBreakpoint) return;

    const descElement = document.querySelector(CONFIG.selector);
    
    // Mostra il pulsante solo se il testo è significativamente più lungo del taglio (es. +50px)
    if (!descElement || descElement.scrollHeight <= CONFIG.maxHeight + 50) return;
    if (descElement.parentNode.querySelector('.js-read-more-btn')) return;

    descElement.classList.add('is-truncated');

    const btn = document.createElement('button');
    btn.className = 'js-read-more-btn';
    btn.innerText = CONFIG.btnTextOpen;

    descElement.parentNode.insertBefore(btn, descElement.nextSibling);

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isTruncated = descElement.classList.contains('is-truncated');

      if (isTruncated) {
        // APRI
        descElement.classList.remove('is-truncated');
        descElement.classList.add('is-expanded');
        btn.innerText = CONFIG.btnTextClose;
        btn.style.marginTop = "10px"; // Ripristina margine normale quando aperto
      } else {
        // CHIUDI
        descElement.classList.remove('is-expanded');
        descElement.classList.add('is-truncated');
        btn.innerText = CONFIG.btnTextOpen;
        btn.style.marginTop = "-20px"; // Rimetti margine negativo
        descElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  initReadMore();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth <= CONFIG.mobileBreakpoint) initReadMore();
    }, 250);
  });
});